export const GET_ALL_COUNTRIES = 'GET_ALL_COUNTRIES'
export const GET_COUNTRY_BY_ID = 'GET_COUNTRY_BY_ID'
export const GET_COUNTRY_DETAIL = 'GET_COUNTRY_DETAIL'
export const ADD_ACTIVITY = 'ADD_ACTIVITY';
export const SEARCH_COUNTRY = 'SEARCH_COUNTRY';
export const SEARCH_BY_CONTINENT = 'SEARCH_BY_CONTINENT';
export const SORT_BY_NAME = 'SORT_BY_NAME';
export const SORT_BY_POPULATION = 'SORT_BY_POPULATION';
export const CHANGE_PAGE = 'CHANGE_PAGE';
export const SELECTED_ACTIVITY = 'SELECTED_ACTIVITY'
export const SORT_BY_AREA = 'SORT_BY_AREA'
export const SET_LOADING = 'SET_LOADING'